import React, { useState, useEffect } from "react";
import contentfulRichText from "../util/contentfulRichText";
import { truncateRichText } from "../../util/transforms";

export default ({ text, readMoreText = "Read more", length = 100 }) => {
    const [currentText, setCurrentText] = useState("");
    const [isIntro, setIsIntro] = useState(true);
    const shortText = truncateRichText(text, length);

    useEffect(() => {
        const short = textElement(shortText);
        setCurrentText(short);
    }, []);

    // The text can be either rich text or string
    const textElement = input => typeof input === "string" ? <p>{ input }</p> : contentfulRichText(input);

    const expandText = () => {
        setIsIntro(false);
        setCurrentText(textElement(text));
    };

    return (
        (isIntro) ?
            <div className="m-expandable-text">
                { currentText }
                <button className="m-expandable-text__btn a-btn a-btn--transparent a-btn--no-space"
                        onClick={ expandText }> { readMoreText } </button>
            </div>
            : currentText
    )
};